export class TimeSlot {
  id: number;
  from: string;
  to: string;

  // only for display
  selected?: boolean;
}
